/**
 * --------------------------------------------------------------------------
 * NJ : Radio.js
 * --------------------------------------------------------------------------
 */

import { Data, Manipulator, Testing } from 'nj-utils';
import AbstractFormBaseSelection from './AbstractFormBaseSelection';
import { coreConfig } from 'nj-components/core.config';


/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME = 'radio';
const DATA_KEY = `${coreConfig.KEY_PREFIX}.${NAME}`;

const SELECTOR = '.nj-radio > label > input[type=radio]';

const DEFAULT_CONFIG = {
  template: '<span class="nj-radio__decorator"></span>',
  njFormGroup: {
    required: false
  }
};

class Radio extends AbstractFormBaseSelection {
  constructor(element, config, properties = {
    inputType: 'radio',
    outerClass: 'nj-radio'
  }) {
    super(Radio, element, Manipulator.extend(true, DEFAULT_CONFIG, config), properties);
    this.element = element;

    if (this.element) {
      Data.setData(element, DATA_KEY, this);
    }
  }

  dispose() {
    Data.removeData(this.element, DATA_KEY);
    this.element = null;
  }

  static init(options) {
    return super.init(this, options, SELECTOR);
  }

  static getInstance(element) {
    return Data.getData(element, DATA_KEY);
  }

  static matches(element) {
    return element.getAttribute('type') === 'radio';
  }

  static rejectMatch(component, element) {
    Testing.assert(
      this.element,
      this.matches(element),
      `${component} component element ${Testing.describe(
        element
      )} is invalid for type='radio'.`
    );
  }

  // Static
  static selector = SELECTOR;
}

export default Radio;
